import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Item, ProductItem } from '../../shared-core/models/cart-data.model';
import { CartService } from '../../shared-core/services/cart.service';

@Component({
  selector: 'app-product-savedforlater-list',
  templateUrl: './product-savedforlater-list.component.html',
  styleUrls: ['./product-savedforlater-list.component.scss'],
})
export class ProductSavedForLaterListComponent implements OnInit {
  Model: ProductItem[];
  cardItemCount: number;
  IsWaiting: boolean;

  productListWaitingSubscription: Subscription;

  constructor(public service: CartService) { }

  ngOnInit(): void {
    this.service.SavedforLaterCartDataSubject.subscribe((model) => {
      this.cardItemCount = model?.length || 0;
      this.Model = model;
    });
    this.productListWaitingSubscription = this.service.isLoadingSubject.subscribe((waiting) => {
      this.IsWaiting = waiting;
    });

    this.service.loadSavedForLaterCartInfo();
  }

  ngOnDestroy(): void {
    this.productListWaitingSubscription.unsubscribe();
  }

  public getImageURL(imgURI: string) {
    if (!imgURI) return 'https://img.vistek.net/prodimg/200/blank.jpg?tr=w-75,h-75';
    return 'https://img.vistek.net' + imgURI[0];
  }
  public getPlanImageURL(imgURI: string) {
    if (!imgURI) return 'https://img.vistek.net/prodimg/200/blank.jpg?tr=w-75,h-75';
    let imageName = imgURI.substring(3, imgURI.length - 2); // replace('[', '').replace(']', '').replace('"', '').replace('"', '');
    return 'https://img.vistek.net/' + imageName;
  }

  public changeItemQuantity(item: ProductItem) {
    this.service.changeItemQuantity(item);
  }
  public moveItemToCart(item: Item) {
    this.service.moveSavedItemToCart(item);
  }
  public removeItem(item: Item) {
    this.service.removeSavedForlaterItem(item);
  }
  public saveItem(item: any) {
    alert('Item Saved!!');
  }
}
